import { allTrackers } from "app/services/track/track";

import { createAdvancedSearchFilteringTrackingService } from "./factory";

const advancedSearchFilteringTrackingService = createAdvancedSearchFilteringTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default advancedSearchFilteringTrackingService;
